import { css } from '@emotion/react';

export default $ => css`
  .uweentity-note-sidepanel-component {
    display: flex;
    flex-direction: column;

    .note-compose {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 12px 16px;
      background: ${$.gray100};
      border-bottom: 2px solid ${$.primaryMain};

      .note-compose-input {
        width: 100%;
        min-height: 72px;
        border: 1px solid ${$.cardBorderColor};
        border-radius: 8px;
        padding: 8px 10px;
        font-size: 13px;
        line-height: 1.5;
        resize: none;
        background: ${$.white};
        transition: border-color 0.15s, box-shadow 0.15s;

        &:focus {
          outline: none;
          border-color: ${$.primaryMain};
          box-shadow: 0 0 0 3px ${$.primaryMain}33;
        }
      }

      .note-compose-send {
        align-self: flex-end;
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 5px 14px;
        font-size: 12px;
        border-radius: 6px;
      }
    }

    .uweentity-notes-list {
      display: flex;
      flex-direction: column;
    }
  }

  .note-card {
    padding: 12px 16px;
    border-bottom: 1px solid ${$.gray100};

    &:last-child {
      border-bottom: none;
    }

    &.note-pending {
      background: ${$.warningMain}18;
      border-left: 3px solid ${$.warningMain};
      padding-left: 13px;
    }

    .note-card-meta {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 7px;
    }

    .note-avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      color: ${$.white};
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      flex-shrink: 0;
      letter-spacing: 0;
    }

    .note-card-info {
      display: flex;
      flex-direction: column;
      gap: 1px;
      min-width: 0;
    }

    .note-user {
      font-size: 12px;
      font-weight: 600;
      color: ${$.gray800};
      line-height: 1.2;
    }

    .note-date {
      font-size: 10px;
      color: ${$.gray500};
      line-height: 1.2;
    }

    .note-text {
      font-size: 13px;
      color: ${$.gray700};
      white-space: pre-wrap;
      line-height: 1.5;
    }
  }
`;
